import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Payment from './pages/Payment';
import Show from './pages/Show';
import EmailLogin from './pages/EmailLogin';
import Profile from './pages/Profile';
import Test from './pages/Test';
import Error from './pages/Error'
import PaymentTest from './pages/PaymentTest';
import Weedings from './pages/Weedings';
import Weedings2 from './pages/Weedings2';
import WomenDays from './pages/WomenDays';
import Weedings3 from './pages/Weedings3';
function About() {
  return (<>
  </>);
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/letuyet-tranxin/*" element={<Weedings/>} />
      <Route path="/tranxin-letuyet/*" element={<Weedings2/>} />
      <Route path="/viettrinh-huutri/*" element={<Weedings3/>} />
      <Route path="/women-days/*" element={<WomenDays/>} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path='/payment/:orderId' element={<Payment/>}/>
      <Route path='/login/email' element={<EmailLogin/>}/>
      <Route path='/profile/info' element={<Profile/>}/>
      <Route path='/test' element={<Test/>}/>
      <Route path='/payment/test/:orderId' element={<PaymentTest/>}/>
      <Route path='*' element={<Error/>}/>
    </Routes>
  );
}

export default App;
